import {Bubble} from '@deviceinsight/ng-ui-basic-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import warning_icon from '../../assets/icon_warning_triangle.svg';

type DatapointListProps = {
	datapoints: Array<string>;
	i18nKey: string;
	defaultValue: string;
	classNames?: string;
};

type TooltipProps = {
	availableDatapoints: Array<string>;
	missingDatapoints: Array<string>;
};

const DatapointList = ({datapoints, i18nKey, defaultValue, classNames}: DatapointListProps) => {
	if (datapoints.length) {
		return (
			<div className={`datapointlist ${classNames || ''}`}>
				<span className="datapointlist-header">
					<Trans i18nKey={i18nKey}>{defaultValue}</Trans>
				</span>
				<div>
					{datapoints.map((dp, i) => (
						<div key={i}>{dp}</div>
					))}
				</div>
			</div>
		);
	} else {
		return null;
	}
};

const TooltipBubble = ({availableDatapoints, missingDatapoints}: TooltipProps) => {
	const datapointCount = availableDatapoints.length + missingDatapoints.length;
	return (
		<Bubble
			style={{
				marginLeft: '-12px'
			}}
			content={
				<div className="tooltip-bubble">
					<DatapointList
						datapoints={availableDatapoints}
						i18nKey="asset.detail.dataProcessingDefinition.columns.datapoint"
						defaultValue="Datapoints"
					/>
					<DatapointList
						datapoints={missingDatapoints}
						i18nKey="asset.detail.dataProcessingDefinition.columns.missingDatapoints"
						defaultValue="Missing Datapoints"
						classNames="missing"
					/>
				</div>
			}>
			<div className="kpi-datapoints">
				{!!missingDatapoints.length && (
					<span className="kpi-datapoints-icon">
						<img src={warning_icon} alt="warning" />
					</span>
				)}
				<span className="kpi-datapoints-count">{datapointCount}</span>
			</div>
		</Bubble>
	);
};

export default TooltipBubble;
